import FilterButton from "./FilterButton";

const ArchiveHeader = (props) => {
  const {
    isMobile,
    activeFilter,
    setActiveFilter,
    filterOrder,
    setFilterOrder,
    setMobileFiltersOpen,
  } = props;

  return (
    <>
      <section className="archive__header-wrapper">
        <div
          className={`archive__item number ${
            activeFilter === "mixNumber" ? "active" : ""
          }`}
        >
          <FilterButton
            {...{
              activeFilter,
              setActiveFilter,
              filterOrder,
              setFilterOrder,
            }}
            value={"mixNumber"}
            text={!isMobile ? "No." : "Mix Number"}
            classes={""}
          />
          {!isMobile ? (
            <FilterButton
              {...{
                activeFilter,
                setActiveFilter,
                filterOrder,
                setFilterOrder,
              }}
              value={"title"}
              text={"Artist(s)"}
              classes={"artists"}
            />
          ) : (
            ""
          )}
        </div>
        {isMobile ? (
          <div
            className={`archive__item number ${
              activeFilter === "title" ? "active" : ""
            }`}
          >
            <FilterButton
              {...{
                activeFilter,
                setActiveFilter,
                filterOrder,
                setFilterOrder,
              }}
              value={"title"}
              text={"Artist Name"}
              classes={"artists"}
            />
          </div>
        ) : (
          ""
        )}
        <div
          className={`archive__item duration ${
            activeFilter === "duration" ? "active" : ""
          }`}
        >
          <FilterButton
            {...{
              activeFilter,
              setActiveFilter,
              filterOrder,
              setFilterOrder,
            }}
            value={"duration"}
            text={"Duration"}
            classes={""}
          />
        </div>
        <div
          className={`archive__item plays ${
            activeFilter === "plays" ? "active" : ""
          }`}
        >
          <FilterButton
            {...{
              activeFilter,
              setActiveFilter,
              filterOrder,
              setFilterOrder,
            }}
            value={"plays"}
            text={"Listens"}
            classes={""}
          />
        </div>
        {/* <div
          className={`archive__item genre ${
            activeFilter === "genre" ? "active" : ""
          }`}
        >
          <FilterButton
            {...{
              activeFilter,
              setActiveFilter,
              filterOrder,
              setFilterOrder,
            }}
            value={"genre"}
            text={"Genre"}
            classes={""}
          />
        </div> */}
        <div
          className={`archive__item ${activeFilter === "favs" ? "active" : ""}`}
        >
          <FilterButton
            {...{
              activeFilter,
              setActiveFilter,
              filterOrder,
              setFilterOrder,
            }}
            value={"favs"}
            text={"Likes"}
            classes={""}
          />
        </div>
        <div
          className={`archive__item date ${
            activeFilter === "releaseDate" ? "active" : ""
          }`}
        >
          <FilterButton
            {...{
              activeFilter,
              setActiveFilter,
              filterOrder,
              setFilterOrder,
            }}
            value={"releaseDate"}
            text={"Release Date"}
            classes={""}
          />
        </div>
        {isMobile ? (
          <div className={`archive__item active`}>
            <button
              className={`ra__button`}
              onClick={() => {
                setMobileFiltersOpen(true);
              }}
            >
              <div className="archive__filters-open-button" />
            </button>
          </div>
        ) : (
          ""
        )}
      </section>
    </>
  );
};

export default ArchiveHeader;
